import $ from "jquery";

export function SubmenuToggle(selector = ".js-submenu-toggle") {
  const $element = $(selector);
  const OPEN_CLASS = "is-open";
  let openCount = 0;
  const $mobileMenu = $(".js-mobile-menu");

  function toggle($target, element) {
    $target.toggleClass(OPEN_CLASS);
    $(element).toggleClass(OPEN_CLASS);

    var expanded = $target.attr("aria-expanded");
    if (expanded == "false") {
      openCount++;
      expanded = "true";
    } else {
      openCount--;
      expanded = "false";
    }
    $target.attr("aria-expanded", expanded);
    if (openCount) {
      $mobileMenu.addClass(OPEN_CLASS);
    } else {
      $mobileMenu.removeClass(OPEN_CLASS);
    }
  }

  function handleClick(e) {
    e.preventDefault();
    e.stopPropagation();
    const element = e.currentTarget;
    const target = e.currentTarget.dataset.target;
    toggle($(target), element);
  }

  $element.click(e => handleClick(e));
}
